import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { SitesTable } from '~/components/settings/masterData/site/SitesTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/masterdata/sites/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/sites',
    ...routeParams,
  }),
  component: SitesTable,
  validateSearch,
});

export const MASTERDATA_SITES = buildRouteExport({ Route, ...routeParams });
